import emailjs from 'emailjs-com'
import {
  EMAILJS_USER_ID,
  EMAILJS_SERVICE_ID,
  EMAILJS_TEMPLATE_ID,
} from '../../env'

const EMAIL_ERROR_MESSAGES = {
  400: 'Thông tin gửi không hợp lệ, hãy liên hệ admin',
  401: 'Quyền không hợp lý, vui lòng liên hệ admin',
  422: 'Email nhận không hợp lệ',
  500: 'Máy chủ đang gặp sự cố',
}
export const EMAILJS_CONFIG = {
  USER_ID: EMAILJS_USER_ID, // Thay thế bằng userID của bạn
  SERVICE_ID: EMAILJS_SERVICE_ID, // Thay thế bằng serviceID của bạn
  TEMPLATE_ID: EMAILJS_TEMPLATE_ID, // Thay thế bằng templateID của bạn
}

/**
 * Gửi email thông qua dịch vụ EmailJS.
 * @param {Object} templateParams - {log_id, content, và to_email}.
 * @returns {Promise<Object>} - Trả về thông tin kết quả gửi email.
 * @throws {Error} - Ném lỗi với thông báo chi tiết nếu gửi email thất bại.
 */
export const send_email_service = async ({ to_email, content, log_id }) => {
  const templateParams = {
    to_email: to_email,
    content: content,
    log_id: log_id,
  }
  try {
    const response = await emailjs.send(
      EMAILJS_CONFIG.SERVICE_ID,
      EMAILJS_CONFIG.TEMPLATE_ID,
      templateParams,
      EMAILJS_CONFIG.USER_ID
    )
    return {
      success: true,
      message: 'Gửi phản hồi thành công',
      data: response,
    }
  } catch (error) {
    const errorMessage = 'Gửi phản hồi thất bại'
    const errorDetail = EMAIL_ERROR_MESSAGES[error?.status] || 'không xác định'

    return {
      success: false,
      message: errorMessage,
      error: errorDetail,
    }
  }
}
